<template>
    <div id="manifestTables">
        <div slot="header" class="clearfix mb-1">
            <h5 class="float-left">{{ title }} - To be picked up</h5>
        </div>
        <div v-for="booking in bookings" :key="booking.id">
            <el-table
                ref="manifestTable"
                :data="booking"
                style="width: 100%"
                border
                stripe
                :summary-method="getSummaries"
                show-summary
                class="mb-3"
                empty-text="No Bookings"
                :row-key="getRowKey"
                deselect-on-clickaway="false"
                @selection-change="handleSelectionChange($event, booking[0].carrierId, title)"
            >
                <el-table-column
                    :label="'Carrier: ' + booking[0].carrierName"
                    label-class-name="h5"
                >
                    <el-table-column type="selection" width="50" :reserve-selection="true">
                    </el-table-column>
                    <el-table-column prop="number" label="Booking #" fixed width="100">
                    </el-table-column>
                    <el-table-column prop="reference" label="Reference #" width="120">
                    </el-table-column>
                    <el-table-column prop="customer" label="Customer" width="200">
                    </el-table-column>
                    <el-table-column prop="deliveryAddress" label="Delivery Address" width="200">
                    </el-table-column>
                    <el-table-column prop="region" label="Region" width="100"> </el-table-column>
                    <el-table-column prop="lines.quant" label="Quantity" width="100">
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{ line.quantity }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="lines.type"
                        label="Package Type"
                        width="150"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{ line.packageType.data.name }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="lines.desc"
                        label="Description"
                        width="150"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{ line.description }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="lines.dg"
                        label="DG Class"
                        width="100"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{
                                    line.dgLines.length > 0
                                        ? line.dgLines[0].product.data.un.data.class
                                        : "Not DG"
                                }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lines.weight" label="Weight (Kg)" width="120">
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{ Math.trunc(line.weight) }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lines.volume" label="Volume (m3)" width="120">
                        <template slot-scope="scope">
                            <div v-for="(line, index) in scope.row.lines" :key="line.id">
                                {{ line.volume }}
                                <hr
                                    v-if="index != scope.row.lines.length - 1"
                                    style="margin-left:-10px; margin-right:-10px"
                                />
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ManifestTable",
    props: {
        bookings: {
            type: Object
        },
        title: {
            type: String,
            default: 'Manifest Table'
        }
    },
    data() {
        return {
            selected: []
        };
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 7) {
                    sums[index] = "Item(s)";
                    return;
                }

                const quant = data.map(item => item.quantity);
                const weight = data.map(item => item.weight);
                const volume = data.map(item => item.volume);

                if (index === 6) {
                    sums[index] = quant.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                }

                if (index === 10) {
                    sums[index] = weight.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return parseFloat(prev) + parseFloat(curr);
                        } else {
                            return parseFloat(prev);
                        }
                    }, 0);
                    sums[index] = sums[index].toFixed(2);
                }

                if (index === 11) {
                    sums[index] = volume.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return parseFloat(prev) + parseFloat(curr);
                        } else {
                            return parseFloat(prev);
                        }
                    }, 0);

                    sums[index] = sums[index].toFixed(2);
                }
            });

            return sums;
        },
        getRowKey(row) {
            return row.id;
        },
        handleSelectionChange(rows, carrier, title) {
            this.selected[carrier] = rows;
            this.$emit("selected", this.selected, title);
        }
    }
};
</script>

<style type="text/css" media="print">
@page {
    size: landscape;
}
</style>
